// extracted by mini-css-extract-plugin
export default {"agreement":"agreement--N_hha","circle-icon":"circle-icon--yjcuj","press":"press--MoiKr"};